/* eslint-disable import/prefer-default-export */
import moment from 'moment';

export const getDateWithFormat = (val, fm) => {
  if (!val || !fm) return '';
  return moment(val).format(fm);
};
export const getMomentDate = (val, isToday) => {
  if (!val && !!isToday) return moment();
  if (!val) return '';
  return moment(val);
};
